module.exports = __webpack_public_path__ + "static/img/logo.a3cc90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 222